import { Container, Divider, Grid } from '@material-ui/core';
import { ArrowBack, Save as SaveIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { InfoMvmAddOutgoingInvoice, MvmOutgoingRequest, MvmRackLoad } from '../../interfaces/Mvm';
import MvmApi from '../../services/MvmApi';
import MvmOutgoingRequestList from './components/MvmOutgoingRequestList';
import MvmRackLoadList from './components/MvmRackLoadList';
import MvmSummary from './components/MvmSummary';
import { useStyles } from './Style';

interface Params {
    mvmNumber: string;
}

interface IFormInput {
    mvmNumber: any;
    mvmNumberUnique: string;
    rackLoads: any;
    outgoingRequests: any;
}

const AddMvmOutgoingInvoice: React.FC = () => {
    const history = useHistory()
    const classes = useStyles()
    const { t } = useTranslation("Mvm")
    const { t: _t } = useTranslation("General")
    const { enqueueSnackbar } = useSnackbar()
    const [mvm, setMvm] = useState<any>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [queryMvmId, setQueryMvmId] = useState<any>(null)
    const { control, handleSubmit, setValue, getValues } = useForm<IFormInput>(
    {
        defaultValues: { mvmNumber: {}, mvmNumberUnique: '' }
    })

    useEffect(() => {
        var mvmId = Number(window.location.pathname.replace('/AddMvmOutgoingInvoice/', ''));
        if (!isNaN(mvmId))
            setQueryMvmId(mvmId)

    }, [window.location.pathname]);

    useEffect(() => {
        if (!mvm)
            return

        //Preencher as descricoes de cada item da lista, para ser exibido corretamente na tela (TODO: Isto deveria ficar dentro de MvmOutgoingRequestList.)
        mvm.outgoingRequests.forEach((x: any) => {
            x['supplierName'] = x['supplierId'] + ' - ' + x['supplierCorporateName'];
            x['requestTypeDescription'] = x['outgoingRequestType'];
        });

        setValue("outgoingRequests", mvm.outgoingRequests)
        
        //Cada Shed tem uma colecao de RackLoads - esta tela deve exibir todos os racks de todos os sheds
        let rackLoads: any = [];
        mvm.sheds.forEach((x: any) => {
            //Incluir os rackLoads de cada shed na lista:
            x.rackLoads.forEach((y: any) => {         
                y.rackLoadId = y.id; //Setar este ID para obter depois, pois a propriedade "id" é sobrescrita pelo react hook form FieldArray
                rackLoads.push(y);
            });
        });

        setValue("outgoingRequests", mvm.outgoingRequests)
        setValue("rackLoads", rackLoads.filter((item:any) => !(['DIV', 'D07', 'D19'].indexOf(item.rackTypeCode) == 0)).sort((a: any, b: any) => b.requestNumber - a.requestNumber))
    }, [mvm])

    const onSummaryChange = (data: any) => {
        
        if (!data) {
            setMvm(null)
            return
        }

        setMvm(data)
    }

    const onSubmit = (data: any) => {
        if (!mvm) {
            enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
            return
        }

        if (mvm.composition && mvm.mvmType !== 'C') {
            enqueueSnackbar(t("mvmCabinCannotContainInvoices"), { variant: 'warning' })
            return
        }

        setIsLoading(true)

        let hasErrors: boolean = false;

        let putObject: InfoMvmAddOutgoingInvoice = { 
            id: mvm.id, 
            outgoingRequests: [],
            rackLoads: []
        }
        data.outgoingRequests.forEach((e: any) => 
        {
            if (e.hasError) //Se tem algum erro em tela no campo da nota fiscal, cancelar a operacao
                hasErrors = true;

            let item: MvmOutgoingRequest = {
                id: 0,
                mvmId: mvm.id,
                outgoingRequestType: e.outgoingRequestType,
                requestNumber: e.requestNumber,
                supplierId: e.supplierId,
                supplierCorporateName: e.supplierCorporateName,
                invoiceKey: e.invoiceKey,
                invoiceNumber: e.invoiceNumber
            }
            putObject.outgoingRequests.push(item)
        });

        data.rackLoads.filter((rl: any) => rl.requestNumber).forEach((e: any) => {
        });
       
       let currentInvoiceNumber = 0;
       let currentInvoiceKey = 0;
       let currentRequestNumber = 0;
       let oldRequestNumber = 0;
       
        for (let i = data.rackLoads.length - 1; i >= 0; i--) {
            // Se não possuir RequestNumber
            if (!data.rackLoads[i].requestNumber) continue

            // Atribuindo o requestNumber da posicão atual
            currentRequestNumber = data.rackLoads[i].requestNumber;

            // Comparando com o último avaliado
            // Se os RequestNumberrs forem diferentes, memorizar novo RequestNumber
            if (currentRequestNumber !== oldRequestNumber) {
                currentInvoiceNumber = data.rackLoads[i].invoiceNumber;
                currentInvoiceKey = data.rackLoads[i].invoiceKey;
            }
            // Se for o mesmo, atribuir o InvoiceNumber
            else {
                data.rackLoads[i].invoiceNumber = currentInvoiceNumber;
                data.rackLoads[i].invoiceKey = currentInvoiceKey;
            }

            // Memorizando o RequestNumber atual como o antigo para comparação com o próximo membro
            oldRequestNumber = currentRequestNumber;
        }

        data.rackLoads.forEach((e: any) => 
        {
            if (e.hasError) //Se tem algum erro em tela no campo da nota fiscal, cancelar a operacao
                hasErrors = true;

            let item: MvmRackLoad = {
                id: e.rackLoadId, //e.id é alterado pelo FieldArray, portanto vamos restaurar esse valor aqui
                mvmShedId: e.mvmShedId,
                supplierId: e.supplierId,
                supplierName: e.supplierName,
                supplierUF: e.supplierUF,
                loadType: e.loadType,
                rackTypeId: e.rackTypeId,
                rackTypeCode: e.rackTypeCode,
                rackTypeOwnerSupplierId: e.rackTypeOwnerSupplierId,
                rackTypeDescription: e.rackTypeDescription,
                rackTypeQuantity: e.rackTypeQuantity,
                requestNumber: e.requestNumber,
                invoiceKey: e.invoiceKey,
                invoiceNumber: e.invoiceNumber,
                invoiceCFOP: e.invoiceCFOP,
                rackDispatchReturnMessage: e.rackDispatchReturnMessage,
                shippingCompanyId: e.shippingCompanyId,
                shippingCompanyUF: e.shippingCompanyUF,
                shippingCompanyCode: e.shippingCompanyCode,
                pendingBillingResolutionUser: e.pendingBillingResolutionUser,
                pendingBillingResolutionUserName: e.pendingBillingResolutionUserName,
                pendingBillingResolutionDate: e.pendingBillingResolutionDate,
                indFullRack: e.indFullRack,
                pendingTransportOrderResolutionUser: e.pendingTransportOrderResolutionUser,
                pendingTransportOrderResolutionUserName: e.pendingTransportOrderResolutionUserName,
                pendingTransportOrderResolutionDate: e.pendingTransportOrderResolutionDate,
                volumeQuantity: e.volumeQuantity,
                invoiceGroup: e.invoiceGroup,
            }
            putObject.rackLoads.push(item)
        });

        
        if (!hasErrors)
            MvmApi.addMvmOutgoingInvoice(putObject)
            .then(() => {
                enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' });
                history.push('/PendingBilling');
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <Container maxWidth={false} component="main">
    
            <PageTitle title={t("titleOutgoingInvoiceInsert")} />

            {
                isLoading ? <LoadingUI /> :
                (
                <div className={classes.rootContent}>
                    <form onSubmit={handleSubmit(onSubmit)} >                    
                        <Divider style={{ marginTop: '10px' }} />
                        <MvmSummary
                            control={control}
                            name={"summary"}
                            onChange={onSummaryChange}
                            setValue={setValue}
                            queryMvmId={queryMvmId}
                            includeProperties={["Sheds", "OutgoingRequests"]}
                        />
                    </form>
                        
                    {!mvm ? <></> : 
                        <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {
                                        <>
                                            <MvmRackLoadList
                                                control={control}
                                                title={t('titleOutgoingRackInvoiceRequest')}
                                                name={"rackLoads"}
                                                allowAdd={false}
                                                allowDelete={false}
                                                allowInvoiceEdit={true}
                                                showColumns={['shedCode', 'requestNumber', 'rackDispatchReturnMessage']}
                                            />

                                            <MvmOutgoingRequestList
                                                control={control}
                                                title={t('titleOutgoingMaterialInvoiceRequest')}
                                                name={"outgoingRequests"}
                                                allowAdd={false}
                                                allowDelete={false}
                                                allowInvoiceEdit={true}
                                            />
                                        </>
                                    }
                                </Grid>
                                <ButtonUI
                                    style={{ marginTop: 15 }}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => history.replace('/PendingBilling')}
                                    startIcon={<ArrowBack />}>
                                    {'Voltar '}
                                </ButtonUI>
                                <ButtonUI
                                    style={{ marginTop: 15, marginLeft: 15 }}
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => onSubmit(getValues())}
                                    startIcon={<SaveIcon />}>
                                    {_t("save")}
                                </ButtonUI>
                        </Grid>                
                    }
                </div>
                )
            }
        </Container>
    )
}
export default AddMvmOutgoingInvoice;
